import axios from "axios"

export default async function getCampaignV2ProductDropdown({ id, search }) {
    return new Promise((resolve, reject) => {
        axios.get(`/campaignV2/customer/campaign/productList`, {
            params: {
                uuid: id,
                search,
            }
        })
        .then((response) => resolve(response.data))
        .catch((error) => {
            return reject(error.response.data)
        })
    })
}
